
import { mapState } from 'vuex'
import utils from '@/components/tools/utils'

export default {

  props: {},

  computed: {
    ...mapState('upload', ['attributes']),
    ...mapState('product', {
      entityId: state => state.data?.entityId,
      product: state => state.data
    }),

    productAttributes () {
      return Object.values(this.product.attributes)
    },
    flattened () {
      const elems = []

      this.moreInformationSections.forEach((section) => {
        elems.push(section)
        section.attributes.forEach((attribute) => {
          elems.push(attribute)
        })
      })
      return elems
    },

    moreInformationSections () {
      const sections = [
        {
          titleKey: 'product.repaired_damage_details',
          attributeGroup: 'product_more_information_damage'
        },
        {
          titleKey: 'product.damage_details',
          attributeGroup: 'product_more_information_damage_not_repaired'
        },
        {
          titleKey: 'product.repaired_water_damage_details',
          attributeGroup: 'product_more_information_water_damage'
        },
        {
          titleKey: 'product.water_damage_details',
          attributeGroup: 'product_more_information_water_damage_not_repaired'
        },
        {
          titleKey: 'product.repaired_hail_damage_details',
          attributeGroup: 'product_more_information_hail_damage'
        },
        {
          titleKey: 'product.hail_damage_details',
          attributeGroup: 'product_more_information_hail_damage_not_repaired'
        }
      ]
      const moreInformationAttributes = this.productAttributes.filter(
        attribute => attribute.attributeSetName === 'product_more_information'
      )
      const groupedMoreInformationAttributes = this.groupBy(
        moreInformationAttributes,
        attribute => attribute.attributeGroupName
      )

      return sections
        .filter(
          section =>
            section.attributeGroup in groupedMoreInformationAttributes
        )
        .map(section => ({
          title: this.$t(section.titleKey),
          attributes: groupedMoreInformationAttributes[section.attributeGroup]
        }))
    }
  },
  methods: {
    formatAttributeValue ({ backendType, attributeCode, value }) {
      if (backendType === 'int') {
        return this.attributes[attributeCode].options.find(
          option => option.optionId === value
        ).label
      }

      if (backendType === 'decimal') {
        return utils.formatCurrency(value)
      }

      return value
    },
    groupBy (items, keySelector) {
      const groups = {}

      for (const item of items) {
        const key = keySelector(item)

        if (!(key in groups)) {
          groups[key] = []
        }

        groups[key].push(item)
      }

      return groups
    }
  }
}

